export default __webpack_public_path__ + "static/media/Kuthcheman Claymore.61ebf4e4.jpg";